export const SET_IS_LONGIN = 'SET_IS_LONGIN'
export const SET_LONGIN_UID = 'SET_LONGIN_UID'
export const SET_LOGINST = 'SET_LOGINST'
export const SET_IMLOGIN = 'SET_IMLOGIN'
// lenovo_sig
export const SET_LOGIN_SIG = 'SET_LOGIN_SIG'
export const SET_ENGINEER_INFO = 'SET_ENGINEER_INFO'
export const SET_USER_INFO = 'SET_USER_INFO'
// 发送消息
export const SEND_MESSAGE = 'SEND_MESSAGE'
export const USER_SEND_MESSAGE = 'USER_SEND_MESSAGE'
export const SET_SESSION_ID = 'SET_SESSION_ID'
export const UPDATE_SENDING_STATE = 'UPDATE_SENDING_STATE'
export const UPDATE_MESSAGE_STATE_ERROR = 'UPDATE_MESSAGE_STATE_ERROR'
export const UPDATE_MESSAGE_STATE_SUCCESS = 'UPDATE_MESSAGE_STATE_SUCCESS'
export const AUDIO_PLAYING = 'AUDIO_PLAYING'
export const SET_START_TIME = 'SET_START_TIME'
// session
export const UPDATE_DEFAULTSESSION = 'UPDATE_DEFAULTSESSION'
export const TRY_SWITCH_SESSION = 'TRY_SWITCH_SESSION'
export const SET_QINIU_TOKEN = 'SET_QINIU_TOKEN'
export const SET_SESSION_ITEM = 'SET_SESSION_ITEM'
export const UPDATE_USER_SEND_MESSAGE = 'UPDATE_USER_SEND_MESSAGE'
export const CLEAR_USER_SEND_MESSAGE = 'CLEAR_USER_SEND_MESSAGE'
export const SET_SCREEN_TYPE = 'SET_SCREEN_TYPE'

export const RELOAD_CUSTOMER_IMAGE = 'RELOAD_CUSTOMER_IMAGE'
export const DELETE_MESSAGE_FROM_LIST = 'DELETE_MESSAGE_FROM_LIST'

export const IS_ENGNINEER = 'IS_ENGNINEER'



// WEBPACK FOOTER //
// ./src/store/modules/call-center/mutation-types.js